<!-- eslint-disable -->
<template>
  <CommonPages id="home" :class="['home']" :titlePrefix="domainConfig?.siteName || 'Home'"
    :metaDescription="domainConfig?.['meta']?.des || 'Default des'" header-theme="dark">
    <!-- 使用动态组件渲染，根据domainConfig配置的顺序 -->
    <!-- Banner部分 -->
    <div class="home-banner">
      <div class="home-banner__container">
        <div class="home-banner__content" @click="goToAllCategories">
          <h1 class="home-banner__title">Explore and read Good novels for free</h1>
          <p class="home-banner__description">
            Free access to a vast number of good novels on GoodNovel app. Download the books you
            like and read anywhere & anytime.
          </p>
          <div class="home-banner__cta">
            <img src="@/assets/list.svg" alt="icon" class="home-banner__cta-icon">
            <div class="home-banner__cta-text">Start Read</div>
          </div>
        </div>
      </div>
    </div>

    <AdComponent v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_1"
      ref="ads-home-1" class="pc_padding m_padding" :ads="adsensConfig?.home_1"
      :showDebug="showDebug" />

    <!-- Top Books部分 -->
    <div class="top-books">
      <div class="top-books__header">
        <div class="top-books__title">Top Books</div>
      </div>
      <div class="top-books__carousel-container" v-if="topBooks.length > 0 && !loading">
        <div class="top-books__books"
          :class="{'top-books__books--mobile': deviceType === 'mobile'}">
          <BookCard
            v-for="(book, index) in (deviceType === 'mobile' ? topBooks : paginatedTopBooks)"
            :key="index" :book="book" @click="goToDetail(book)" />
        </div>
      </div>
      <div class="top-books__controls">
        <div class="top-books__pagination" v-if="deviceType !== 'mobile'">
          <img src="@/assets/vector-left.svg" alt="Previous" @click="prevTopBooksPage"
            :class="{'disabled': topBooksCurrentPage === 1}" class="top-books__arrow">
          <div class="top-books__dots">
            <span v-for="page in topBooksTotalPages" :key="page" class="top-books__dot"
              :class="{'active': page === topBooksCurrentPage}"
              @click="goToTopBooksPage(page)"></span>
          </div>
          <img src="@/assets/vector-right.svg" alt="Next" @click="nextTopBooksPage"
            :class="{'disabled': topBooksCurrentPage === topBooksTotalPages}"
            class="top-books__arrow">
        </div>
        <div class="top-books__more" @click="goToAllCategories">
          <div class="top-books__more-text">More Books</div>
          <img src="@/assets/more-icon.svg" alt="More" class="top-books__more-icon">
        </div>
      </div>
    </div>

    <!-- Editor's Choice 部分 -->
    <div class="editors-choice">
      <div class="editors-choice__header">
        <div class="editors-choice__title">Editor's Choice</div>
      </div>
      <div v-if="loadingEditors" class="editors-choice__loading">
        <!-- 这里可以放置加载中的骨架屏或提示 -->
      </div>
      <div v-else-if="error" class="editors-choice__error">
        <div class="editors-choice__error-text">{{ error }}</div>
      </div>
      <template v-else-if="editorsChoice && editorsChoice.length > 0">
        <div class="editors-choice__carousel-container">
          <div class="editors-choice__books"
            :class="{'editors-choice__books--mobile': deviceType === 'mobile'}">
            <BookCard
              v-for="(book, index) in (deviceType === 'mobile' ? editorsChoice : paginatedEditorsChoice)"
              :key="index" :book="book" layout="horizontal" @click="goToDetail(book)" />
          </div>
        </div>
        <div class="editors-choice__controls">
          <div class="editors-choice__pagination" v-if="deviceType !== 'mobile'">
            <img src="@/assets/vector-left.svg" alt="Previous" @click="prevEditorsChoicePage"
              :class="{'disabled': editorsChoiceCurrentPage === 1}" class="editors-choice__arrow">
            <div class="editors-choice__dots">
              <span v-for="page in editorsChoiceTotalPages" :key="page" class="editors-choice__dot"
                :class="{'active': page === editorsChoiceCurrentPage}"
                @click="goToEditorsChoicePage(page)"></span>
            </div>
            <img src="@/assets/vector-right.svg" alt="Next" @click="nextEditorsChoicePage"
              :class="{'disabled': editorsChoiceCurrentPage === editorsChoiceTotalPages}"
              class="editors-choice__arrow">
          </div>
          <div class="editors-choice__more" @click="goToAllCategories">
            <div class="editors-choice__more-text">More Books</div>
            <img src="@/assets/more-icon.svg" alt="More" class="editors-choice__more-icon">
          </div>
        </div>
      </template>
    </div>

    <AdComponent v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_2"
      ref="ads-home-2" class="m_padding pc_padding" :ads="adsensConfig?.home_2"
      :showDebug="showDebug" />

    <!-- Recently Updated 部分 -->
    <div class="recently-updated">
      <div class="recently-updated__header">
        <div class="recently-updated__title">Recently Updated</div>
      </div>
      <div v-if="loadingRecently" class="recently-updated__loading">
        <!-- Loading... -->
      </div>
      <div v-else-if="error" class="recently-updated__error">
        <div class="recently-updated__error-text">{{ error }}</div>
      </div>
      <template v-else-if="recentlyUpdated && recentlyUpdated.length > 0">
        <div class="recently-updated__carousel-container">
          <div class="recently-updated__books"
            :class="{'recently-updated__books--mobile': deviceType === 'mobile'}">
            <BookCard
              v-for="(book, index) in (deviceType === 'mobile' ? recentlyUpdated : paginatedRecentlyUpdated)"
              :key="index" :book="book" layout="cover-hover" @click="goToDetail(book)" />
          </div>
        </div>
        <div class="recently-updated__controls">
          <div class="recently-updated__pagination" v-if="deviceType !== 'mobile'">
            <img src="@/assets/vector-left.svg" alt="Previous" @click="prevRecentlyUpdatedPage"
              :class="{'disabled': recentlyUpdatedCurrentPage === 1}"
              class="recently-updated__arrow">
            <div class="recently-updated__dots">
              <span v-for="page in recentlyUpdatedTotalPages" :key="page"
                class="recently-updated__dot"
                :class="{'active': page === recentlyUpdatedCurrentPage}"
                @click="goToRecentlyUpdatedPage(page)"></span>
            </div>
            <img src="@/assets/vector-right.svg" alt="Next" @click="nextRecentlyUpdatedPage"
              :class="{'disabled': recentlyUpdatedCurrentPage === recentlyUpdatedTotalPages}"
              class="recently-updated__arrow">
          </div>
          <div class="recently-updated__more" @click="goToAllCategories">
            <div class="recently-updated__more-text">More Books</div>
            <img src="@/assets/more-icon.svg" alt="More" class="recently-updated__more-icon">
          </div>
        </div>
      </template>
    </div>

    <!-- Popular Categories 部分 -->
    <div class="popular-categories">
      <div class="popular-categories__header">
        <div class="popular-categories__title">Popular Categories</div>
      </div>
      <div class="popular-categories__items"
        :class="{'popular-categories__items--mobile': deviceType === 'mobile'}">
        <div v-for="category in filteredCategories" :key="category.value"
          class="popular-categories__item" @click="goToCategoryPage(category.value)">
          {{ category.displayName }}
        </div>
      </div>
      <div class="popular-categories__more" @click="goToAllCategories">
        <div class="popular-categories__more-text">More Categories</div>
        <img src="@/assets/more-icon.svg" alt="More" class="popular-categories__more-icon">
      </div>
    </div>

    <AdComponent v-if="deviceType == 'mobile'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_3" ref="ads-home-3"
      class="m_padding" :ads="adsensConfig?.home_3" :showDebug="showDebug" />

    <!-- Rankings 部分 -->
    <div class="rankings">
      <div class="rankings__header">
        <div class="rankings__title">Rankings</div>
      </div>
      <div class="rankings__lists">
        <!-- Weekly Hot Books -->
        <div class="rankings__list" v-if="weeklyRankings && weeklyRankings.length > 0">
          <div class="rankings__list-header">Weekly Hot Books</div>
          <div v-if="loadingRankings" class="rankings__loading">
            <!-- Loading... -->
          </div>
          <div v-else class="rankings__items">
            <RankCard v-for="(book, index) in weeklyRankings" :key="index" :book="book"
              layout="cover-hover" @click="goToBookDetail(book)" />
          </div>
        </div>

        <!-- Monthly Hot Books -->
        <div class="rankings__list" v-if="monthlyRankings && monthlyRankings.length > 0">
          <div class="rankings__list-header">Monthly Hot Books</div>
          <div v-if="loadingRankings" class="rankings__loading">
            <!-- Loading... -->
          </div>
          <div v-else class="rankings__items">
            <RankCard v-for="(book, index) in monthlyRankings" :key="index" :book="book"
              layout="cover-hover" @click="goToBookDetail(book)" />
          </div>
        </div>

        <!-- Yearly Hot Books -->
        <div class="rankings__list" v-if="yearlyRankings && yearlyRankings.length > 0">
          <div class="rankings__list-header">Yearly Hot Books</div>
          <div v-if="loadingRankings" class="rankings__loading">
            <!-- Loading... -->
          </div>
          <div v-else class="rankings__items">
            <RankCard v-for="(book, index) in yearlyRankings" :key="index" :book="book"
              layout="cover-hover" @click="goToBookDetail(book)" />
          </div>
        </div>
      </div>
      <div class="rankings__more" @click="goToRankings">
        <div class="rankings__more-text">More Books</div>
        <img src="@/assets/more-icon.svg" alt="More" class="rankings__more-icon">
      </div>
    </div>

    <AdComponent v-if="deviceType == 'mobile'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.home_4" ref="ads-home-4"
      class="m_padding" :ads="adsensConfig?.home_4" :showDebug="showDebug" />

    <!-- Meet Reader Satisfaction 部分 -->
    <div class="satisfaction" v-show="feedbackList.length > 0">
      <div class="satisfaction__header">
        <div class="satisfaction__title">Meet Reader Satisfaction</div>
      </div>

      <!-- 反馈数据 -->
      <div class="satisfaction__reviews">
        <!-- 使用v-for循环遍历评价数据 -->
        <div class="satisfaction__review" v-for="(feedback, index) in feedbackList" :key="index">
          <div class="satisfaction__review-rating">
            <!-- 根据评分动态显示星星 -->
            <img src="@/assets/default/star-icon.svg" alt="Star" class="satisfaction__star"
              v-for="star in feedback.rating" :key="'star-'+star">
          </div>
          <div class="satisfaction__review-body">
            <div class="satisfaction__review-info">
              <img :src="feedback.avatar || require('@/assets/default/placeholder.png')"
                alt="avatar" class="satisfaction__review-avatar">
              <div class="satisfaction__reviewer">{{ feedback.name }}</div>
            </div>
            <div class="satisfaction__review-content">
              {{ feedback.content }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import AdComponent from '@/pages/components/AdComponent.vue'
import BookCard from '@/components/BookCard.vue';
import RankCard from '@/components/RankCard.vue';

import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import '@/css/home.scss';

export default {
  name: 'Home',
  components: {
    CommonPages,
    AdComponent,
    BookCard,
    RankCard
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      topBooksCurrentPage: 1,
      editorsChoiceCurrentPage: 1,
      topBooks: [],
      editorsChoice: [],
      recentlyUpdated: [],
      loading: false,
      loadingEditors: false,
      loadingRecently: false,
      error: null,
      // 新增排行榜数据
      weeklyRankings: [],
      monthlyRankings: [],
      yearlyRankings: [],
      loadingRankings: false,
      // 新增用户反馈数据
      feedbackList: [],
      loadingFeedback: false,
      recentlyUpdatedCurrentPage: 1,
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
      'categories',
      'getCategoryByValue'
    ]),
    filteredCategories () {
      if (!this.categories || !Array.isArray(this.categories) || this.categories.length === 0) {
        return [];
      }

      const popularCategoriesConfig = this.domainConfig?.popularCategories || [];

      // 过滤掉value为"all"的分类
      const filteredCats = this.categories.filter(cat => cat.value !== 'all');

      if (popularCategoriesConfig.length > 0) {
        return popularCategoriesConfig
          .map(categoryValue => filteredCats.find(cat => cat.value === categoryValue))
          .filter(category => category !== undefined);
      } else {
        return filteredCats.slice(0, 10);
      }
    },
    topBooksTotalPages () {
      return Math.ceil(this.topBooks.length / 4);
    },
    paginatedTopBooks () {
      const start = (this.topBooksCurrentPage - 1) * 4;
      const end = start + 4;
      return this.topBooks.slice(start, end);
    },
    editorsChoiceTotalPages () {
      // 每页显示3个
      return Math.ceil(this.editorsChoice.length / 3);
    },
    paginatedEditorsChoice () {
      const start = (this.editorsChoiceCurrentPage - 1) * 3;
      const end = start + 3;
      return this.editorsChoice.slice(start, end);
    },
    recentlyUpdatedTotalPages () {
      // 每页显示6个
      return Math.ceil(this.recentlyUpdated.length / 6);
    },
    paginatedRecentlyUpdated () {
      const start = (this.recentlyUpdatedCurrentPage - 1) * 6;
      const end = start + 6;
      return this.recentlyUpdated.slice(start, end);
    }
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component activated`);
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component mounted`);
    }
    // 确保分类数据已加载
    await this.ensureCategoriesLoaded();

    // 当组件激活时获取热门书籍数据
    this.fetchTopBooks();
    // 获取编辑推荐数据
    this.fetchEditorsChoice();
    // 获取最近更新数据
    this.fetchRecentlyUpdated();
    // 获取排行榜数据
    this.fetchRankings();
    // 获取用户反馈数据
    this.fetchFeedback();

    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });

    // 确保分类数据已加载
    await this.ensureCategoriesLoaded();

    // 当组件挂载时获取热门书籍数据
    this.fetchTopBooks();
    // 获取编辑推荐数据
    this.fetchEditorsChoice();
    // 获取最近更新数据
    this.fetchRecentlyUpdated();
    // 获取排行榜数据
    this.fetchRankings();
    // 获取用户反馈数据
    this.fetchFeedback();
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component deactivated`);
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Home] Component beforeDestroy`);
    }
  },
  methods: {
    nextTopBooksPage () {
      if (this.topBooksCurrentPage < this.topBooksTotalPages) {
        this.topBooksCurrentPage++;
      }
    },
    prevTopBooksPage () {
      if (this.topBooksCurrentPage > 1) {
        this.topBooksCurrentPage--;
      }
    },
    goToTopBooksPage (page) {
      this.topBooksCurrentPage = page;
    },
    nextEditorsChoicePage () {
      if (this.editorsChoiceCurrentPage < this.editorsChoiceTotalPages) {
        this.editorsChoiceCurrentPage++;
      }
    },
    prevEditorsChoicePage () {
      if (this.editorsChoiceCurrentPage > 1) {
        this.editorsChoiceCurrentPage--;
      }
    },
    goToEditorsChoicePage (page) {
      this.editorsChoiceCurrentPage = page;
    },
    nextRecentlyUpdatedPage () {
      if (this.recentlyUpdatedCurrentPage < this.recentlyUpdatedTotalPages) {
        this.recentlyUpdatedCurrentPage++;
      }
    },
    prevRecentlyUpdatedPage () {
      if (this.recentlyUpdatedCurrentPage > 1) {
        this.recentlyUpdatedCurrentPage--;
      }
    },
    goToRecentlyUpdatedPage (page) {
      this.recentlyUpdatedCurrentPage = page;
    },
    // 获取热门书籍数据
    async fetchTopBooks () {
      this.loading = true;
      try {
        // 调用global.js中定义的getTopBooks方法
        const response = await this.$global.server.getTopBooks();

        if (response && response.data) {
          // 如果API返回成功且有数据
          // 根据实际返回的数据结构进行映射
          this.topBooks = Array.isArray(response.data) ? response.data.map(book => ({
            id: book.id,
            title: book.novelName,
            author: book.novelAuthorName,
            coverImage: book.bigImg,
            category: book.novelType,
            rating: book.novelScoreStr,
            novelId: book.novelId
          })) : [];
        } else {
          // 如果API返回无数据，使用空数组
          console.warn('API returned data format does not match expectations');
          this.topBooks = [];
        }
      } catch (error) {
        console.error('Failed to fetch top books:', error);
        this.error = 'No data';
        // 使用空数组
        this.topBooks = [];
      } finally {
        this.loading = false;
      }
    },

    // 获取编辑推荐数据
    async fetchEditorsChoice () {
      this.loadingEditors = true;
      try {
        // 调用global.js中定义的getEditorsChoice方法
        const response = await this.$global.server.getEditorsChoice();

        if (response && response.data) {
          // 如果API返回成功且有数据
          // 根据实际返回的数据结构进行映射
          this.editorsChoice = Array.isArray(response.data) ? response.data.map(book => ({
            id: book.id,
            title: book.novelName,
            author: book.novelAuthorName,
            coverImage: book.bigImg,
            category: book.novelType,
            rating: book.novelScoreStr,
            novelId: book.novelId
          })) : [];
        } else {
          // 如果API返回无数据，使用空数组
          console.warn('API returned editor\'s choice data format does not match expectations');
          this.editorsChoice = [];
        }
      } catch (error) {
        console.error('Failed to fetch editor\'s choice:', error);
        this.error = 'No data';
        // 使用空数组
        this.editorsChoice = [];
      } finally {
        this.loadingEditors = false;
      }
    },

    // 获取最近更新数据
    async fetchRecentlyUpdated () {
      this.loadingRecently = true;
      try {
        // 调用global.js中定义的getRecentlyUpdated方法
        const response = await this.$global.server.getRecentlyUpdated();

        if (response && response.data) {
          // 如果API返回成功且有数据
          // 根据实际返回的数据结构进行映射
          this.recentlyUpdated = Array.isArray(response.data) ? response.data.map(book => ({
            id: book.id,
            title: book.novelName,
            author: book.novelAuthorName,
            coverImage: book.bigImg,
            category: book.novelType,
            rating: book.novelScoreStr,
            novelId: book.novelId
          })) : [];
        } else {
          // 如果API返回无数据，使用空数组
          console.warn('API returned recently updated data format does not match expectations');
          this.recentlyUpdated = [];
        }
      } catch (error) {
        console.error('Failed to fetch recently updated:', error);
        this.error = 'No data';
        // 使用空数组
        this.recentlyUpdated = [];
      } finally {
        this.loadingRecently = false;
      }
    },

    // 前往全部分类页面
    goToAllCategories () {
      // 重定向到"all"分类路由
      this.$router.push('/all');
    },

    // 前往书籍详情页
    goToDetail (book) {
      // 构建URL参数 - 路由格式：/:categories/:novelName/:id
      const categoryParam = book.category.toLowerCase().replace(/\s+/g, '-');
      const titleParam = book.novelId ? book.novelId : book.title.toLowerCase().replace(/\s+/g, '-');
      const idParam = book.id;

      // 重定向到详情页
      this.$router.push(`/${categoryParam}/${titleParam}/${idParam}`);
    },

    // 获取排行榜数据
    async fetchRankings () {
      this.loadingRankings = true;
      try {
        // 调用global.js中定义的getRankList方法
        const response = await this.$global.server.getRankList();

        console.log(response);

        if (response.data && response.data.result) {
          // 新的API返回格式为 {"result": {"MONTH": [], "YEAR": [], "WEEK": []}}
          const rankData = response.data.result;

          const mapBook = (book, index) => ({
            id: book.id,
            novelId: book.novelId,
            title: book.novelName,
            author: book.novelAuthorName,
            coverImage: book.bigImg,
            rating: book.novelScoreStr,
            category: book.novelType || 'Fiction',
            rank: index + 1
          });

          if (rankData.WEEK && Array.isArray(rankData.WEEK)) {
            this.weeklyRankings = rankData.WEEK.map(mapBook).slice(0, 10);
          }

          if (rankData.MONTH && Array.isArray(rankData.MONTH)) {
            this.monthlyRankings = rankData.MONTH.map(mapBook).slice(0, 10);
          }

          if (rankData.YEAR && Array.isArray(rankData.YEAR)) {
            this.yearlyRankings = rankData.YEAR.map(mapBook).slice(0, 10);
          }
        } else {
          console.warn('API返回的排行榜数据格式不符合预期，使用默认数据');
          // 如果API返回无数据，保持现有静态数据
        }
      } catch (error) {
        console.error('获取排行榜数据失败:', error);
      } finally {
        this.loadingRankings = false;
      }
    },

    // 从排行榜前往书籍详情页
    goToBookDetail (book) {
      if (!book || !book.id) return;

      // 构建URL - 路由格式：/:categories/:novelName/:id
      const categoryParam = (book.category || 'fiction').toLowerCase().replace(/\s+/g, '-');
      const titleParam = book.novelId ? book.novelId : book.title.toLowerCase().replace(/\s+/g, '-');
      const idParam = book.id;

      // 重定向到书籍详情页
      this.$router.push(`/${categoryParam}/${titleParam}/${idParam}`);
    },

    // 前往分类页面
    goToCategoryPage (category) {
      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        this.$router.push(`/${this.$route.params.channel}/${category}`);
      } else {
        // 如果没有channel参数，直接导航到分类页面
        this.$router.push(`/${category}`);
      }
    },

    // 前往排行榜页面
    goToRankings () {
      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        this.$router.push(`/${this.$route.params.channel}/rank`);
      } else {
        // 如果没有channel参数，直接导航到排行榜页面
        this.$router.push('/rank');
      }
    },

    // 获取用户反馈数据
    async fetchFeedback () {
      this.loadingFeedback = true;
      try {
        // 调用global.js中定义的getFeedback方法
        const response = await this.$global.server.getFeedback();

        if (response && response.success && response.data) {
          // 如果API返回成功且有数据
          this.feedbackList = Array.isArray(response.data) ? response.data.map(feedback => ({
            id: feedback.id,
            name: feedback.userName || 'Anonymous User',
            rating: feedback.rating || 5,
            content: feedback.content || 'Great experience with this platform!',
            avatar: feedback.avatar || null // 添加头像字段
          })) : [];

        } else {
          // 如果API返回无数据，使用默认数据
          console.warn('API返回的用户反馈数据格式不符合预期，使用默认数据');
        }
      } catch (error) {
        console.error('获取用户反馈数据失败:', error);
      } finally {
        this.loadingFeedback = false;
      }
    },

    // 确保分类数据已经加载
    async ensureCategoriesLoaded () {
      // 检查分类数据是否已加载
      if (!this.$store.getters.categoriesLoaded) {
        try {
          // 等待分类数据加载完成
          return await new Promise(resolve => {
            const checkCategoriesLoaded = () => {
              if (this.$store.getters.categoriesLoaded) {
                resolve();
              } else {
                setTimeout(checkCategoriesLoaded, 100);
              }
            };
            checkCategoriesLoaded();
          });
        } catch (error) {
          console.error('等待分类数据加载失败:', error);
        }
      }
      return Promise.resolve();
    }
  }
};
</script>
